import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-8 py-24 md:py-32 text-center">
      <span className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-6">
        <i className="ri-compass-3-line text-3xl"></i>
      </span>
      <p className="font-heading text-5xl md:text-6xl font-bold text-primary-500">404</p>
      <h1 className="mt-4 font-heading text-xl md:text-2xl font-semibold text-foreground-950">
        页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-500">
        您访问的页面不存在或已被移除：
        <span className="ml-1 text-foreground-700 break-all">{location.pathname}</span>
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
        >
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm whitespace-nowrap cursor-pointer hover:border-primary-400 hover:text-primary-600 transition-colors"
        >
          浏览国产电影
        </Link>
      </div>
    </div>
  );
}